var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileURL!='')?_c('div',{staticClass:"indexPage"},[_c('job-header-simple',{attrs:{"header_title":_vm.header_title}}),_c('pdf-view',{staticClass:"indexPage1",attrs:{"file":_vm.fileURL}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }